var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title-bar"},[_c('div',{staticClass:"row"},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('span',{staticClass:"close"})]),_c('div',{staticClass:"contents"})])}
var staticRenderFns = []

export { render, staticRenderFns }